<template>
    <div class="product-details__content">
        <div id="review" class="product-review-container" data-tab-contents="review">
            <div class="product-review__head">
                <div class="product-review__order">
                    <span class="product-review__total">구매후기 ({{ summary.totalCount }})</span>
                    <span class="product-review__group">
                        <ul class="product-review__group-lists">
                            <li><a class="on">인기순</a></li>
                            <li><a>최신순</a></li>
                        </ul>
                    </span>
                </div>
                <!-- <div class="product-review__buttons">
                    <div class="button button--border-primary" @click="openModalReview">구매후기 등록</div>
                </div> -->
            </div>
            <div class="product-review__body">
                <div class="review-box-container">
                    <div v-for="review in reviews" :key="review._id" class="review-box">
                        <div class="review-box__head">
                            <div class="review-box__evaluation">
                                <!-- 별점 평가 -->
                                <div class="star-rating-container">
                                    <span v-for="(star, index) in 5" :key="index" class="star-rating">
                                        <svg class="star" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 488.2">
                                            <linearGradient :id="`starOrder${star}`" x1="0" x2="100%" y1="0" y2="0">
                                                <stop :offset="star <= review.star ? '100%' : '0%'" stop-color="#ffdc64"></stop>
                                                <stop :offset="star <= review.star ? '100%' : '0%'" stop-color="#dddddd"></stop>
                                            </linearGradient>
                                            <path d="M499.9,176.4L334.1,161L268.2,8c-4.6-10.7-19.8-10.7-24.4,0l-65.9,153L12.1,176.4c-11.6,1.1-16.3,15.5-7.5,23.2l125.1,109.9L93,472c-2.6,11.4,9.7,20.3,19.7,14.3l143.2-85l143.2,85c10,6,22.3-3,19.8-14.3l-36.6-162.5l125.1-109.9C516.2,191.9,511.5,177.5,499.9,176.4" :fill="`url('#starOrder${star}')`"/>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <span class="review-box__id">
                                <span v-if="review.user">
                                    {{ review.user.name.replace(/(.).(.+)/, "$1*$2") }}
                                </span>
                                <span v-else>탈퇴회원</span>
                            </span>
                            <span class="review-box__date">{{ review.createDate.toDate() }}</span>
                        </div>
                        <div class="review-box__body">
                            <div class="review-box__texts">
                                <p class="review-box__text" v-html="review.content.replace(/\n/g, '<br>')"></p>
                            </div>
                            <div class="review-box__flex">
                                <ul class="review-box__photo-lists">
                                    <li v-for="(image, index) in review.images.filter(image => image)" :key="index" class="review-box__photo-list"><div class="review-box__photo" role="button"><img :src="image" alt=""></div></li>
                                </ul>
                                <div class="review-box__thumbup">
                                    <span class="review-box__thumbup-title">이 리뷰가 도움이 되었나요?</span>
                                    <button class="button" type="button" aria-pressed="true" @click="thumbup(review)"><span>네 <b>+{{ review.thumbup.format() }}</b></span></button>
                                    <button class="button" type="button" aria-pressed="false" @click="thumbdown(review)"><span>아니요 <b>-{{ review.thumbdown.format() }}</b></span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/api";

export default {
    props: {
        product: { type: Object, default: null }
    },
    data() {
        return {
            filter: {
                _product: this.$props.product._id,
            },

            page: 1,
            pageCount: 0,
            limit: 2,

            summary: { totalCount: 0 },
            reviews: []
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },
        async search(){
            try{
                var { reviews } = await api.v1.shop.reviews.getReviews({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit
                    },
                    params: this.filter
                });

                this.reviews = reviews;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async thumbup(review){
            try{
                await this.postThumb({ review, thumb: 1 });
                review.thumbup++;
            }
            catch(error){
                console.error(error);
                if(error.response) alert(error.response.data.message);
                else alert(error.message.toString());
            }
        },

        async thumbdown(review){
            try{
                await this.postThumb({ review, thumb: -1 });
                review.thumbdown--;
            }
            catch(error){
                console.error(error);
                if(error.response) alert(error.response.data.message);
                else alert(error.message.toString());
            }
        },

        postThumb({ review, thumb }){
            return new Promise(async (resolve, reject) => {
                try{
                    var res = await this.$http.post(`/api/v1/shop/reviews/${review._id}/thumbs`, { thumb });

                    resolve();
                }
                catch(error){
                    reject(error);
                }
            })
        }
    }
}
</script>
